import "./page404.css";

const Page404 = () => {
  return (
    <div className='page-404-container'>
      <h1>404 Page Not Found</h1>
    </div>
  );
};
export { Page404 };
